import { observer } from 'mobx-react';
import { Box, Container } from '@mui/material';
import Header from './Header';
import Footer from './Footer';

function Layout({ children, maxWidth = 'xl', ...props }) {
  const { ...otherProps } = props;
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
      }}>
      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', mb: 2 }}>
        <Container disableGutters maxWidth={false} {...otherProps}>
          <Header sx={{ mb: 2.5 }} />
          <Container maxWidth={maxWidth}>{children}</Container>
        </Container>
      </Box>
      <Footer maxWidth={maxWidth} />
    </Box>
  );
}

export function LayoutFullWidth({ children, maxWidth = 'xl', ...props }) {
  const { ...otherProps } = props;
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
      }}>
      <Box sx={{ flex: 1 }}>
        <Container disableGutters maxWidth={false} {...otherProps}>
          <Header sx={{ mb: 0.2 }} />
          {children}
        </Container>
      </Box>
      <Footer maxWidth={maxWidth} />
    </Box>
  );
}

export default observer(Layout);
